import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';
import { Theme } from '@/utils/constants';

import { ThreeColumnContentProps } from './ThreeColumnContent.interface';
import useStyles from './ThreeColumnContent.styles';
import { MuiTypography } from '../material-ui';

const ThreeColumnContent = ({
  title,
  leftColumn,
  centerColumn,
  rightColumn,
  theme = Theme.light,
  className,
  ...props
}: PropsWithChildren<ThreeColumnContentProps>) => {
  const classes = useStyles({});

  const rootClasses = clsx(classes.root, `${theme}-theme`, className);
  return (
    <div data-testid="qa-three-col-content" className={rootClasses}>
      {title && (
        <MuiTypography variant="overline" component="h2" className={classes.title}>
          {title}
        </MuiTypography>
      )}

      <div className={clsx(classes.columns, 'columns')}>
        {leftColumn && (
          <div
            className={clsx(
              classes.column,
              'column',
              'left-column',
              props?.isAutoLayout && 'column-auto',
            )}
          >
            {leftColumn}
          </div>
        )}

        {centerColumn && (
          <div
            className={clsx(
              classes.column,
              'column',
              'center-column',
              props?.isAutoLayout && 'column-auto',
            )}
          >
            {centerColumn}
          </div>
        )}

        {rightColumn && (
          <div
            className={clsx(
              classes.column,
              'column',
              'right-column',
              props?.isAutoLayout && 'column-auto',
            )}
          >
            {rightColumn}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(ThreeColumnContent);
